var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  version: 1.1,
  id: "Capa_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    "enableBackground": "new 0 0 512 512"
  },
  xmlSpace: "preserve",
  width: "512px",
  height: "512px"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M346,422H166c-8.284,0-15,6.716-15,15s6.716,15,15,15h180c8.284,0,15-6.716,15-15S354.284,422,346,422z",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#1273EB"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M346,302H166c-8.284,0-15,6.716-15,15s6.716,15,15,15h180c8.284,0,15-6.716,15-15S354.284,302,346,302z",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#1273EB"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M346,362H166c-8.284,0-15,6.716-15,15s6.716,15,15,15h180c8.284,0,15-6.716,15-15S354.284,362,346,362z",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#1273EB"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 121,
  width: 210,
  height: 130,
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#1273EB"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M507.606,84.394l-80-80C424.793,1.581,420.978,0,417,0h-56v145c0,8.284-6.716,15-15,15H106c-8.284,0-15-6.716-15-15V0H15    C6.716,0,0,6.716,0,15v482c0,8.284,6.716,15,15,15c4.645,0,475.762,0,482,0c8.284,0,15-6.716,15-15V95    C512,91.022,510.419,87.207,507.606,84.394z M391,482H121V272h270V482z",
  "data-original": "#000000",
  className: "active-path",
  "data-old_color": "#000000",
  fill: "#1273EB"
}))))));
export default __webpack_public_path__ + "teg/media/save.b069b38f.svg";
export { SvgComponent as ReactComponent };